import { render, staticRenderFns } from "./PGridAlert.vue?vue&type=template&id=6cb751ee&scoped=true&"
import script from "./PGridAlert.vue?vue&type=script&lang=ts&"
export * from "./PGridAlert.vue?vue&type=script&lang=ts&"
import style0 from "./PGridAlert.vue?vue&type=style&index=0&id=6cb751ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb751ee",
  null
  
)

export default component.exports